// eslint-disable-next-line import/prefer-default-export
export const PerksbarContactEmail = 'hello@perksbar.com';
